import { Controller } from "@hotwired/stimulus"
import { chromeIntentUrl, shouldPromptOpenInBrowser } from "./webviewEscape.mjs"

export default class extends Controller {
  connect() {
    if (shouldPromptOpenInBrowser(navigator.userAgent || navigator.vendor || window.opera || "")) {
      this.showAlert()
    }
  }

  showAlert() {
    const div = document.createElement("div")
    div.className = "fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
    div.innerHTML = `
      <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm text-center">
        <h2 class="text-lg font-semibold mb-3 text-gray-900">In-app browser detected</h2>
        <p class="text-sm text-gray-700 mb-5">
          It looks like you're viewing this page inside an app (e.g. Gmail, Instagram).
          For the best experience, please open it directly in Chrome.
        </p>
        <a href="${chromeIntentUrl(location)}"
           class="inline-block px-4 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition-all">
          Open in Chrome
        </a>
        <div class="mt-4 flex justify-center gap-4 text-sm">
          <button type="button" data-webview-action="copy" class="text-gray-700 underline">Copy link</button>
          <button type="button" data-webview-action="dismiss" class="text-gray-700 underline">Continue here</button>
        </div>
      </div>
    `
    div.querySelector('[data-webview-action="copy"]').addEventListener("click", async (event) => {
      try {
        await navigator.clipboard.writeText(location.href)
        event.target.textContent = "Link copied"
      } catch (error) {
        window.prompt("Copy this link", location.href)
      }
    })
    div.querySelector('[data-webview-action="dismiss"]').addEventListener("click", () => div.remove())
    document.body.appendChild(div)
  }
}
